/** NOTES
 * Pour conserver uen cohérence avec le format des données du back,
 * la chaine de caractère contenant les uri sera toujours initié par un point d'interrogation "?"
 */

export const PostParametersView = Backbone.View.extend({
  el: '#mainContainer',

  events: {
    'click .js-postParams': 'postParams'
  },

  initialize: function () {
    this.currentUri = decodeURI(GLOBAL_SCRIPTS.URI_PARAMS).replace(/&amp;/g, '&');//paramètres de l'uri en version string
    this.listenTo(dispatcher, 'postParams:initBackNav', this.initBackNav);
    this.listenTo(dispatcher, 'postParams:updateCurrentUri', this.updateCurrentUri);
    this.listenTo(dispatcher, 'postParams:initPostParamsLink', this.initPostParamsLink);
    this.listenTo(dispatcher, 'postParams:globalUpdate', this.globalUpdate);
  },

  initPostParamsLink: function (selector = '.js-postParams') {
    $(selector).off('click.postParams').on('click.postParams', event => {
      this.postParams(event);
    });
  },

  postParams: function (event) {
    event.preventDefault();
    const $link = $(event.currentTarget),
      $originClick = $(event.target),
      params = $link.attr('data-urlparams'),
      url = $link.attr('href'),
      target = $link.attr('target'),
      oParams = [],
      arrCouples = params.slice(params.indexOf('?') + 1).replace(/&amp;/g, '&').replace(/%5B/g, '[').replace(/%5D/g, ']').split('&');

    //création d'un tableau avec tous les paramètres
    $(arrCouples).each((idx, item) => {
      const couple = item.split('=');
      oParams[idx] = [couple[0], couple[1]];

      if (couple[0] === 'hc' && GLOBAL_SCRIPTS.CONTROLLER === 'product' && typeof SEARCH_SCRIPTS !== 'undefined' && SEARCH_SCRIPTS.TOTALCOTTAGE > 1) {
        oParams[idx] = [couple[0], ''];
      }
    });

    //Création dynamique du formulaire
    const form = document.createElement('form');

    form.setAttribute('method', 'POST');
    form.setAttribute('action', url);
    if (typeof target !== 'undefined') {
      form.setAttribute('target', target);
    }

    //passage de l'uri dans les paramètres post, pour ne pas avoir à la reconstruire sur la page cible, si nécessaire
    const champUri = document.createElement('input');
    champUri.setAttribute('type', 'hidden');
    champUri.setAttribute('name', 'uri');
    champUri.setAttribute('value', params);
    form.appendChild(champUri);

    //ajout des paramètres dans le form
    for (let key in oParams) {
      const champCache = document.createElement('input');

      champCache.setAttribute('type', 'hidden');
      champCache.setAttribute('name', oParams[key][0]);
      champCache.setAttribute('value', oParams[key][1]);
      form.appendChild(champCache);
    }

    //Ajout du formulaire à la page et soumission du formulaire
    if (!$originClick.hasClass('priceTooltip-toggle')) {
      document.body.appendChild(form);
      form.submit();
    }
  },

  /*
  * save url into history to avoid form refresh request on navigator back
  *
  */
  initBackNav: function () {
    let refererFP_dirty = decodeURI(GLOBAL_SCRIPTS.URL_CURRENT).replace(/&amp;/g, '&'),
      refererFP = refererFP_dirty.replace(/&facet\[MULTIPARTICIPANTS[0]\]\[ages\]\[[0-9]{0,2}\]/g, 'facet[MULTIPARTICIPANTS][0][ages][]'),//on supprime les clés de 3ème niveau dans les ages
      refererFPClean = refererFP.indexOf('?') ? refererFP.split('?')[0] : refererFP,
      refererHashtag = window.location.hash.substr(1) !== '' ? '#' + window.location.hash.substr(1) : '',
      currentUri_base = decodeURI(this.currentUri).replace(/&amp;/g, '&'),
      currentUri = currentUri_base.indexOf('?') > -1 ? currentUri_base : '?' + currentUri_base,
      refererToPush = currentUri && currentUri !== '?' ? refererFPClean + currentUri + refererHashtag : refererFPClean + refererHashtag;

    if (!this.dateHasBeenSetByUser()) {
      //effacement des dates qui ne sont pas envoyées par l'utilisateur
      refererToPush = refererToPush.replace(/&facet\[DATEEND\]=[0-9]{4}-[0-9]{2}-[0-9]{2}/, '').replace(/&facet\[DATE\]=[0-9]{4}-[0-9]{2}-[0-9]{2}/, '');
    }

    // push url with or without params into history
    try {
      window.history.replaceState({}, '', refererToPush);
    } catch (error) {
      console.error(error);
    }
  },

  //Check if user already has facet date in storedSearchParams cookie
  dateHasBeenSetByUser: function () {
    let dateHasBeenSetByUser = false;
    let storedSearchParams = cookieManagement.getCookie('storedSearchParams');
    if (storedSearchParams !== null) {
      if (storedSearchParams.length) {
        storedSearchParams = JSON.parse(storedSearchParams);
        if (typeof storedSearchParams.date !== 'undefined') {
          dateHasBeenSetByUser = true;
        }
      }
    }
    return dateHasBeenSetByUser;
  },

  // Mise à jour des paramètres de l'uri à cause d'interactions javascript
  // cas concerné : cottage details + flex calendar
  updateCurrentUri: function (currentUri, dataToReplace = {}) {
    if (currentUri) {
      this.currentUri = currentUri;
    } else {
      //reconstruction de l'uri en cours à partir de la version précédente mise à jour par les données à remplacées
      const oParams = {},
        arrAges = [],
        arrAgesMultiCottage = [],
        arrHousings = [],
        arrHousingsSpec = [];

      //création d'un tableau avec tous les paramètres
      $.each(this.currentUri.slice(this.currentUri.indexOf('?') + 1).replace(/&amp;/g, '&').split('&'), (index, item) => {
        if (item.indexOf('=') > 0) {
          const couple = item.split('=');
          if (couple[0] === 'facet[MULTIPARTICIPANTS][0][ages][]') {
            //on fait une exception pour les ages, à cause de leur construction spécifique
            arrAges.push(couple[1]);
          } else if (couple[0] === 'facet[MULTIPARTICIPANTS][1][ages][]') {
            arrAgesMultiCottage.push(couple[1]);
          } else if (couple[0] === 'facet[HOUSINGCATEGORY][]') {
            arrHousings.push(couple[1]);
          } else if (couple[0] === 'facet[HOUSINGSPEC][]') {
            arrHousingsSpec.push(couple[1]);
          } else {
            oParams[couple[0]] = couple[1];
          }
        }
      });

      $.each(dataToReplace, (key, value) => {
        oParams[key] = value;
      });

      //reconstruction de l'uri
      let uriString = '?';
      let separator = uriString === '?' ? '' : '&';

      $.each(oParams, (key, value) => {
        uriString += separator + key + '=' + value;
        separator = '&';
      });

      //ajout des ages
      $.each(arrAges, (_index, age) => {
        uriString += separator + 'facet[MULTIPARTICIPANTS][0][ages][]=' + age;
        separator = '&';
      });

      //ajout des ages multiCottage
      $.each(arrAgesMultiCottage, (_index, age) => {
        uriString += separator + 'facet[MULTIPARTICIPANTS][1][ages][]=' + age;
        separator = '&';
      });

      //ajout des housings category
      $.each(arrHousings, (index, category) => {
        uriString += separator + 'facet[HOUSINGCATEGORY][]=' + category;
        separator = '&';
      });

      //ajout des housings spec
      $.each(arrHousingsSpec, (index, category) => {
        uriString += separator + 'facet[HOUSINGSPEC][]=' + category;
        separator = '&';
      });

      this.currentUri = uriString !== '?' ? uriString : '';

      if (!this.dateHasBeenSetByUser()) {
        this.currentUri = this.currentUri.replace(/&facet\[DATEEND\]=[0-9]{4}-[0-9]{2}-[0-9]{2}/, '').replace(/&facet\[DATE\]=[0-9]{4}-[0-9]{2}-[0-9]{2}/, '');
      }
    }

    //mise à jour des liens disposant de paramètres à passer en post
    $('.js-postParams').each((idx, link) => {
      $(link).attr('data-urlparams', this.currentUri);
    });

    //mise à jour du referer
    this.initBackNav();
  },

  //mise à jour des paramètres post pour tous les liens concernés et du referer
  globalUpdate: function (uriParams, selector = '.js-postParams--global') {
    this.currentUri = uriParams;
    $(selector).attr('data-urlparams', uriParams);
    this.initBackNav();
  }
});